<template>
  <div>
    <div
      v-if="hasK"
      class="d-flex flex-row flex-wrap"
      :class="{ 'justify-sm-space-around': center }"
    >
      <v-card
        v-for="eye in eyesForRxs"
        :key="eye"
        flat
        :min-height="$vuetify.breakpoint.smAndUp ? 110 : 90"
        :color="cardColor"
        :min-width="minCardWidth"
        class="pa-2 d-flex flex-row align-center"
        style="max-width: 100%"
      >
        <optical-cross-image
          v-if="showCrosses"
          :dimensions="55"
          :obj="kObjects[eye]"
          type="keratometry"
          class=""
          :style="'margin-top: -25px'"
          :showHeatmap="true"
        />
        <div class="d-flex flex-column" :class="textColorClass[eye]">
          <div class="d-flex flex-row align-start">
            <div class="pr-4">
              <div v-if="eyesForRxs.length > 1">
                <span class="text-h4">{{ eye.toUpperCase() }}</span>
              </div>
            </div>
            <div class="flex-grow-1">
              <div class="font-weight-bold" :class="textColorClass[eye]">
                <div>{{ kString[eye] }}</div>
                <div>
                  {{ mmString[eye] }}
                </div>
              </div>
            </div>
            <k-information-popup
              v-if="kObjects && kObjects[eye]"
              :kObject="kObjects[eye]"
              :btnColor="iconColorClass[eye]"
              class="ml-2 d-inline-block"
            ></k-information-popup>
          </div>

          <slot :name="'content_' + eye" class="slotDiv my-2"> </slot>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "KSummaryCardPair",
  components: {
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
    KInformationPopup: () => import("@/components/clStuff/KInformationPopup"),
  },
  mixins: [RxMethods, StyleUtilities],
  props: {
    showCrosses: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: true,
    },
    kObjects: null, // an rxObject: {od:RxObject, os:RxObject}
    cardColor: {
      type: String,
      default: "#FFFFFF70",
    },
    minCardWidth: null,
  },
  data: function () {
    return {
      color: { od: "darken-2 green", os: "darken-2 blue" },
      textColor: {
        od: "text--darken-2 green--text",
        os: "text--darken-2 blue--text",
      },
    };
  },
  methods: {},
  computed: {
    eyesForRxs: function () {
      let eyes = [];
      if (this.kObjects?.od) eyes.push("od");
      if (this.kObjects?.os) eyes.push("os");
      return eyes;
    },
    hasK: function () {
      let odRx = this.kObjects?.od && this.isValidFullK(this.kObjects.od);
      let osRx = this.kObjects?.os && this.isValidFullK(this.kObjects.os);
      //   console.log("noOd " + odRx);
      //   console.log("noOs " + osRx);
      return odRx || osRx;
    },
    kString: function () {
      let str = { od: null, os: null };
      if (this.kObjects.od)
        str.od = this.prettyFullKstringDiopters(this.kObjects.od);
      if (this.kObjects.os)
        str.os = this.prettyFullKstringDiopters(this.kObjects.os);
      return str;
    },
    mmString: function () {
      let mmStr = { od: null, os: null };
      // console.log("vertexing!");
      if (this.kObjects.od)
        mmStr.od = this.prettyFullKstringMM(this.kObjects.od);
      if (this.kObjects.os)
        mmStr.os = this.prettyFullKstringMM(this.kObjects.os);
      return mmStr;
    },
  },
};
</script>

<style scoped>
.slotDiv {
  max-width: 320px;
}
</style>
